module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./QuestionnaireView.js"));
	}, "Questionnaire");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=Questionnaire!./src/pages/Shop/Member/Questionnaire/QuestionnaireView.js
// module id = 1014
// module chunks = 431